import './AboutDataStyles.css'

function AboutData () {
  return (
    <div className='about-container'>
      <h1>¿Que es el Tren Maya?</h1>
      <p>
        El emocionante mundo del Tren Maya, es una innovadora joya de
        la ingeniería y el turismo en México. Este tren de ensueño te
        transportará a través de los mágicos paisajes de la región sureste,
        creando una experiencia única que combina el lujo moderno con la riqueza
        histórica y natural de este paraíso tropical. Imagina explorar las
        maravillas de Chiapas, Tabasco, Campeche, Yucatán y Quintana Roo,
        mientras viajas en un tren de alta tecnología diseñado para brindarte
        comodidad y estilo. Nuestro tren, con más de 1,500 kilómetros de vías,
        te llevará a través de exuberantes selvas, ciudades llenas de vida y
        destinos turísticos que te dejarán sin aliento. Pero el Tren Maya es
        mucho más que un medio de transporte: es una experiencia en sí misma.
        Desde la elegancia de sus vagones hasta la atención personalizada, te
        sentirás como un viajero distinguido mientras disfrutas de vistas
        panorámicas que cambian constantemente. Además, ¡prepárate para ser
        parte de la historia mientras cruzamos sitios arqueológicos y culturales
        que cuentan las historias ancestrales de esta tierra! El Tren Maya
        también es un motor de desarrollo local y sostenibilidad. Al viajar con
        nosotros, contribuyes al crecimiento económico de las comunidades a lo
        largo de la ruta y a la protección de la biodiversidad única que nos
        rodea. Cada tramo del viaje te sumergirá en la riqueza de la cultura
        maya y en la belleza natural que define a esta región. Ya sea que estés
        buscando aventuras en la jungla, descanso en playas paradisíacas o un
        viaje en el tiempo a través de antiguas civilizaciones, el Tren Maya es
        tu pasaporte a todo ello. Experimenta la magia y la emoción de descubrir
        México de una manera completamente nueva, mientras te relajas y
        disfrutas del viaje de tu vida. Únete a nosotros en este viaje
        inolvidable a lo largo de las costas caribeñas, las junglas misteriosas
        y los tesoros culturales de la región sureste. ¡El Tren Maya te espera
        para que vivas una aventura que quedará grabada en tus recuerdos para
        siempre!
      </p>
      <h1>Ubicaciones</h1>
      <p>
        ¡Proximanente las ubicaciones!
      </p>
      <h1>Noticias</h1>
      <p>
        Una vez finalizado se agregaran las ubicaciones de las estaciones,
        horarios, precios y lineas de atencion ¡Asi que pendiente a las
        actualizaciones!
      </p>
    </div>
  )
}

export default AboutData
